import { put, delay, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

function* coupleRequestCheck(action) {
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'requestCheck');
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/coupleCheckApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    action.callback(res.data);
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
}


function* coupleRequestAdd(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'requestAdd');
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/coupleEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(500);
  if (res) {
    yield put({
      type: "NOTIFICATION_GET",
    });
    action.callback(res.data);
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* coupleRequestDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'requestDel');
    return axios.post(config.apiUri + "member/coupleEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(500);
  if (res) {
    if (res.data.bool === true) {
      yield put({
        type: "NOTIFICATION_GET",
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment:'カップリングの申し込みをキャンセルしました'} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* coupleReceptionOkCheck(action) {
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/coupleCheckApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    action.callback(res.data);
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
}

function* coupleReceptionOk(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'receptionOk');
    params.append('couple_id', payload.couple_id);
    return axios.post(config.apiUri + "member/coupleEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(500);
  if (res) {
    if (res.data.bool === true) {
      yield put({
        type: "NOTIFICATION_GET",
      });
      action.callback(res.data);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible:true, severity:'error', duration:5000, comment:res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* coupleReceptionNg(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'receptionNg');
    params.append('couple_id', payload.couple_id);
    return axios.post(config.apiUri + "member/coupleEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(500);
  if (res) {
    if (res.data.bool === true) {
      yield put({
        type: "NOTIFICATION_GET",
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment:'カップリングをお断りしました'} });
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible:true, severity:'error', duration:5000, comment:res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}




function* coupleRelease(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'release');
    return axios.post(config.apiUri + "member/coupleEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(500);
  if (res) {
    if (res.data.bool === true) {
      yield put({
        type: "NOTIFICATION_GET",
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment:'カップリングを解除しました'} });
      action.callback();
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('COUPLE_REQUEST_CHECK', coupleRequestCheck),
  takeLatest('COUPLE_REQUEST_ADD', coupleRequestAdd),
  takeLatest('COUPLE_REQUEST_DEL', coupleRequestDel),
  takeLatest('COUPLE_RECEPTION_OK_CHECK', coupleReceptionOkCheck),
  takeLatest('COUPLE_RECEPTION_OK', coupleReceptionOk),
  takeLatest('COUPLE_RECEPTION_NG', coupleReceptionNg),
  takeLatest('COUPLE_RELEASE', coupleRelease),
];

export default saga;
